var spacing$1={xxl:{value:"48px"},xl:{value:"40px"},lg:{value:"32px"},md:{value:"24px"},sm:{value:"16px"},xs:{value:"8px"},xxs:{value:"4px"}};var tokens = {spacing:spacing$1};

var spacing = {
    xxs: tokens.spacing.xxs.value,
    xs: tokens.spacing.xs.value,
    sm: tokens.spacing.sm.value,
    md: tokens.spacing.md.value,
    lg: tokens.spacing.lg.value,
    xl: tokens.spacing.xl.value,
    xxl: tokens.spacing.xxl.value,
};

export { spacing as s };
//# sourceMappingURL=spacing-608a84f4.js.map
